import { Model, attr, fk } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'Architecture';

  static fields = {
    coverUrl: attr(),
    name: attr(),
    url: attr(),
    factoryId: fk({
      to: 'Factory',
      as: 'factory',
      relatedName: 'architectures',
    }),
    userId: fk({
      to: 'User',
      as: 'user',
      relatedName: 'architectures',
    }),
  };

  static reducer({ type, payload }, Architecture) {
    switch (type) {
      case ActionTypes.ARCHITECTURE_FETCH_SUCCEEDED: {
        payload.architectures?.forEach((architecture) => {
          Architecture.upsert(architecture);
        });
        break;
      }
      case ActionTypes.ARCHITECTURE_DELETE:
        Architecture.withId(payload.id).delete();

        break;
      case ActionTypes.ARCHITECTURE_CREATE_SUCCEEDED:
      case ActionTypes.ARCHITECTURE_CREATE_RECEIVED:
        Architecture.upsert(payload.architecture);

        break;
      case ActionTypes.ARCHITECTURE_DELETE_RECEIVED:
        Architecture.withId(payload.architecture.id).delete();

        break;
      default:
    }
  }

  static getOrderedQuerySet() {
    return this.orderBy('id');
  }
}
